{
  "hubspot": {
    "lifecycleStage": {
      "subscriber": "Feliratkozó",
      "lead": "Lead",
      "marketingQualifiedLead": "Marketing minősített lead",
      "salesQualifiedLead": "Értékesítés minősített lead",
      "opportunity": "Lehetőség",
      "customer": "Ügyfél",
      "leadForLater": "Későbbi lead",
      "partnerLead": "Partner lead"
    },
    "leadStatus": {
      "new": "Új",
      "open": "Nyitott",
      "inProgress": "Folyamatban",
      "openDeal": "Nyitott üzlet",
      "attemptedToContact": "Kapcsolatfelvételi kísérlet",
      "connected": "Kapcsolódott",
      "badTiming": "Rossz időzítés",
      "meeting": "Találkozó egyeztetve",
      "qualified": "Minősített",
      "unqualified": "Nem minősített",
      "firstEmail": "Első e-mail elküldve",
      "firstEmailFollowUp1": "Első e-mail | 1. követés",
      "firstEmailFollowUp2": "Első e-mail | 2. követés",
      "appointmentScheduled": "Időpont egyeztetve",
      "notSuitable": "Nem megfelelő",
      "noConcretization": "Nincs konkretizálás"
    },
    "relationship": {
      "b2bLicense": "B2B licenc (végfelhasználóknak)",
      "partnerLicenseWithoutSeats": "Partner licenc (helyek nélkül)",
      "partnerLicenseWithSeats": "Partner licenc (helyekkel)",
      "internationalPartnerLicenseWithSeat": "Nemzetközi partner licenc (üléssel)",
      "internationalPartnerLicenseWithoutSeat": "Nemzetközi partner licenc (ülés nélkül)",
      "internationalB2bLicenseEndUser": "Nemzetközi B2B licenc (végfelhasználó)",
      "externalWorkforceProductDevelopment": "Külső munkaerő termékfejlesztéshez",
      "communityCatalyst": "Community Catalyst",
      "technicalIntegrationPartner": "Technikai integrációs partner"
    }
  }
}
